<template>
  <div class="jersey-numbers-quantity">
    <div v-for="n in 10" :key="n" class="jersey-numbers-quantity__field">
      <label :for="`input-${n}`" class="jersey-numbers-quantity__label">#{{ n - 1 }}</label>
      <input
        :id="`input-${n}`"
        :value="letterNumberArtwork.quantities[n - 1]"
        :maxlength="3"
        type="tel"
        class="jersey-numbers-quantity__input"
        @input="handleChange(n - 1, $event)"
        @blur="handleBlur"
      />
    </div>
  </div>
</template>

<script setup>
import debounce from "lodash.debounce";
import { computed } from "vue";
import { calculateSizes } from "components/jiffy/vue-product-details-dtf/JerseyNumbers/utils";
import { useDtfStore } from "../store";

const MAX_QUANTITY = 999;

const store = useDtfStore();
const letterNumberArtwork = computed(() => store.letterNumberArtwork);

const updatePricing = debounce(() => {
  const { quantity } = letterNumberArtwork.value;
  if (quantity) store.getArtworksPricing();
}, 500);

const handleChange = (field, event) => {
  const { value } = event.target;
  let quantity = value.replace(/[^0-9]/g, "").replace(/^0/, "");
  if (Number(quantity) > 0) {
    quantity = Math.min(Number(quantity), MAX_QUANTITY);
  }
  event.target.value = quantity;

  const quantities = Object.entries({
    ...letterNumberArtwork.value.quantities,
    [field]: quantity
  }).reduce((acc, [number, qty]) => {
    if (qty) {
      acc[number] = qty;
    }
    return acc;
  }, {});
  const totalQuantity = Object.values(quantities).reduce((acc, curr) => acc + Number(curr), 0);
  const style = letterNumberArtwork.value.style || "none";
  const sizes = calculateSizes({ ...letterNumberArtwork.value, quantities, style });
  const width = Object.values(sizes)
    .reduce((sum, current) => sum + current.width, 0)
    .toFixed(2);

  store.updateArtworkValues({
    index: 0,
    quantities,
    quantity: totalQuantity,
    sizes,
    width
  });
  updatePricing();
};

const handleBlur = () => {
  store.updatePdpDates();
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.jersey-numbers-quantity {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @include with-tablet {
    gap: 12px;
  }

  &__field {
    width: 52px;
    text-align: center;
  }

  &__label {
    color: $text-black;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.42;
  }

  &__input {
    width: 100%;
    appearance: none;
    border-radius: 4px;
    border: 1px solid $gray-label;
    background: $white;
    text-align: center;
    padding: 12px;
    color: $black;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42;
  }
}
</style>
